/**
 * SoundManifest
 * Centralizes all sound-related constants and collections
 * Provides a single source of truth for sound references across the game
 */
soundManifest = {
  // Map of sound collections
  collections: {
    // Lower than stake win sounds
    lowerThanStakeWin: ["lowerThanStakeWin1", "lowerThanStakeWin2", "lowerThanStakeWin3"],
    // Small Win sounds <= stake * 2
    smallWin: [ "smallWin1", "smallWin2", "smallWin3" ],
    // Medium Win sounds <= stake * 5
    mediumWin: [ "mediumWin1", "mediumWin2", "mediumWin3" ],
    // High Win sounds > stake * 5
    highWin: [ "highWin1", "highWin2", "highWin3" ],

    buttonPress: [ "buttonPress1", "buttonPress2", "buttonPress3" ],

    zapOverlay: [ "zapOverlay1", "zapOverlay2", "zapOverlay3", "zapOverlay4" ],
    zapStart: [ "zapStart1", "zapStart2", "zapStart3", "zapStart4" ],
    zapLanding: [ "zapLand1", "zapLand2", "zapLand3", "zapLand4", "zapLand5", "zapLand6" ],

    collectCashPot: [ "collectCashPot1", "collectCashPot2" ],
    cashPotLand: [ "cashPotLand1", "cashPotLand2", "cashPotLand3" ],

    // Add other sound collections here as needed
  },

  /**
   * Get a sound from a named collection
   * If the collection has multiple entries, returns a random one
   * If the collection has a single entry, returns that entry
   * If the collection doesn't exist, returns null and logs a warning
   * 
   * @param {string} collectionName - The name of the sound collection
   * @returns {string|null} A sound name from the collection or null if not found
   */
  getSound: function(collectionName) {
    const collection = this.collections[collectionName];
    
    if (!collection) {
      console.warn(`SoundManifest: Collection '${collectionName}' not found`);
      return null;
    }
    
    if (collection.length === 0) {
      console.warn(`SoundManifest: Collection '${collectionName}' is empty`);
      return null;
    }
    
    if (collection.length === 1) {
      return collection[0];
    }
    
    // Return random sound from collection
    return collection[Math.floor(Math.random() * collection.length)];
  },

};